
<template>
  <ul class="nested" >
    <li v-if="current">
      <i class="fas" :class="{ 'fas fa-angle-down': (open && current.hijos), 'fas fa-angle-right': (!open && current.hijos)}"></i>
      <span @click="openclose">
        <i :class="{'os-icon os-icon-bar-chart-up': current.sumaria_o_movimiento=='S', 'os-icon os-icon-refresh-ccw': sumaria_o_movimiento='M'}" class="ic-w mx-1"></i>{{ current.id }} - {{ current.nombre }}
      </span>
      <a class="btn btn-default" href="#">
          <i class="os-icon os-icon-edit"></i>
      </a>
      <ConCuentacontableTreeViewItem v-for="current_hijo in current.hijos" v-bind:key="current_hijo.id"
        :current="current_hijo" v-if="open" />
    </li>
  </ul>
</template>

<script>
import _ from "lodash";

export default {
  components: {
    ConCuentacontableTreeViewItem: () => import('@/components/conta/cuentas_contables/ConCuentacontableTreeViewItem'),
  },
  props: {
    current: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      open: true,
    }
  },
  computed: {

  },
  mounted() {
  },
  methods: {
    isOpen() {
      return this.open;
    },
    openclose() {
      this.open = !(this.open);
    }
  },
};
</script>
